import styled from './_Container/DialogContainer.module.scss';

export const TRANSITION_TIMEOUT = 250;

export const DATA_ELEM_BASE = 'dialog';
export const DATA_ELEM_HEADER = `${DATA_ELEM_BASE}-header`;
export const DATA_ELEM_CONTAINER = `${DATA_ELEM_BASE}-container`;
export const DATA_ELEM_CLOSE_BTN = `${DATA_ELEM_BASE}-close-btn`;

export const RIGHT_TRANSITION_CLASSES = {
  appear: styled.rightEnter,
  appearActive: styled.rightEnterActive,
  enter: styled.rightEnter,
  enterActive: styled.rightEnterActive,
  exit: styled.rightExit,
  exitActive: styled.rightExitActive,
};
